export default __webpack_public_path__ + "static/media/GLTD-class-a.ce573f14.png";